(function () {
  var STYLE_ID = 'amc-welcome-popup';
  var DISMISS_KEY = 'amc_welcome_dismissed';
  var EMBED = 'shopify-forms-embed, form-embed';
  var lastRoot = typeof WeakMap === 'function' ? new WeakMap() : null;
  var designSheet = null;
  var designCss = '';
  var userOpened = false;
  var closing = false;

  function isDismissed() {
    try {
      return window.localStorage.getItem(DISMISS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {}
    userOpened = false;
  }

  function cssFor(url) {
    var photo = url
      ? 'url("' + String(url).replace(/"/g, '\\"') + '")'
      : 'none';

    return (
      ':host {' +
      '  --forms-base-font-size: 14px;' +
      '  --forms-heading-font-size: 22px;' +
      '  --forms-body-font: 400 14px/1.5 "DM Sans", sans-serif;' +
      '  --forms-heading-font: 500 22px/1.3 "DM Sans", sans-serif;' +
      '  --forms-accent-color: #00a99e;' +
      '  --forms-accent-color-hovered-modifier: #00a99e1a;' +
      '  --forms-discount-code-color: #00a99e;' +
      '  --heading-text-color: #042b39;' +
      '  --body-text-color: #3d5a62;' +
      '  --link-text-color: #00a99e;' +
      '  --form-text-color: #042b39;' +
      '  --form-placeholder-color: #3d5a6299;' +
      '  --form-background-color: #ffffff;' +
      '  --button-text-color: #ffffff;' +
      '  --button-background-color: #042b39;' +
      '  --button-close-background-color: #ffffff;' +
      '  --button-close-color: #042b39;' +
      '  --container-background-color: #ffffff;' +
      '  --form-field-border: 0 0 0 1px #c5d9d6;' +
      '  --form-field-border-focused: 0 0 0 2px #00a99e;' +
      '  --form-field-border-radius: 12px;' +
      '  --button-border-radius: 100px;' +
      '  --container-border-radius: 18px;' +
      '  --container-max-w: 420px;' +
      '  --container-shadow: 0 18px 50px rgba(4, 43, 57, 0.22), 0 4px 14px rgba(4, 43, 57, 0.08);' +
      '  --forms-padding-top: 8px;' +
      '  --spacing-size-y: 16px;' +
      '}' +
      '#app-embed[data-layout="floating"],' +
      '[data-form-root="true"] {' +
      '  font-family: "DM Sans", sans-serif !important;' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] {' +
      '  display: flex !important;' +
      '  flex-direction: column !important;' +
      '  overflow: hidden !important;' +
      '  background: #ffffff !important;' +
      '  border: 1px solid rgba(197, 217, 214, 0.7) !important;' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] > div:first-child {' +
      '  display: block !important;' +
      '  position: relative !important;' +
      '  width: 100% !important;' +
      '  height: 210px !important;' +
      '  min-height: 210px !important;' +
      '  max-height: 210px !important;' +
      '  margin: 0 !important;' +
      '  padding: 0 !important;' +
      '  background: transparent !important;' +
      '  flex: 0 0 210px !important;' +
      '  overflow: visible !important;' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] > div:first-child::after {' +
      '  content: "";' +
      '  position: absolute;' +
      '  left: 0;' +
      '  right: 0;' +
      '  top: 0;' +
      '  height: 360px;' +
      '  background-image: ' + photo + ';' +
      '  background-position: center 32%;' +
      '  background-size: cover;' +
      '  background-repeat: no-repeat;' +
      '  pointer-events: none;' +
      '  z-index: 0;' +
      '  -webkit-mask-image: linear-gradient(180deg, #000 0%, #000 38%, rgba(0,0,0,0.75) 52%, rgba(0,0,0,0.4) 68%, rgba(0,0,0,0.15) 84%, transparent 100%);' +
      '  mask-image: linear-gradient(180deg, #000 0%, #000 38%, rgba(0,0,0,0.75) 52%, rgba(0,0,0,0.4) 68%, rgba(0,0,0,0.15) 84%, transparent 100%);' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] > div:first-child::before {' +
      '  content: "10% OFF";' +
      '  position: absolute;' +
      '  left: 16px;' +
      '  top: 16px;' +
      '  z-index: 2;' +
      '  padding: 6px 12px;' +
      '  border-radius: 999px;' +
      '  background: rgba(4, 43, 57, 0.78);' +
      '  color: #ffffff;' +
      '  font-family: "DM Sans", sans-serif;' +
      '  font-size: 11px;' +
      '  font-weight: 500;' +
      '  letter-spacing: 0.08em;' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] > div:nth-child(2) {' +
      '  position: relative;' +
      '  z-index: 1;' +
      '  margin-top: -8px !important;' +
      '  padding-top: 8px !important;' +
      '  background: linear-gradient(180deg,' +
      '    rgba(255,255,255,0) 0%,' +
      '    rgba(255,255,255,0.42) 22%,' +
      '    rgba(255,255,255,0.82) 52%,' +
      '    #ffffff 78%,' +
      '    #ffffff 100%) !important;' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] [data-amc-welcome-close] {' +
      '  top: 12px !important;' +
      '  right: 12px !important;' +
      '  left: auto !important;' +
      '  bottom: auto !important;' +
      '  inset: 12px 12px auto auto !important;' +
      '  z-index: 3 !important;' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] > div:nth-child(2) > section:first-child {' +
      '  margin-top: 0 !important;' +
      '  margin-bottom: 14px !important;' +
      '}' +
      '[role="dialog"][data-sizing="form-wrapper"] h2 {' +
      '  margin-top: 0 !important;' +
      '}' +
      'h2 {' +
      '  font-family: "DM Sans", sans-serif !important;' +
      '  font-weight: 500 !important;' +
      '  color: #042b39 !important;' +
      '  letter-spacing: -0.02em !important;' +
      '  text-align: center !important;' +
      '}' +
      'h2::before {' +
      '  content: "Welcome offer";' +
      '  display: block;' +
      '  width: fit-content;' +
      '  margin: 0 auto 12px;' +
      '  padding: 5px 12px;' +
      '  border-radius: 999px;' +
      '  background: rgba(255,255,255,0.92);' +
      '  box-shadow: 0 1px 8px rgba(4, 43, 57, 0.12);' +
      '  font-size: 11px;' +
      '  font-weight: 500;' +
      '  letter-spacing: 0.08em;' +
      '  text-transform: uppercase;' +
      '  color: #00a99e;' +
      '}' +
      'h2::after {' +
      '  content: "";' +
      '  display: block;' +
      '  width: 48px;' +
      '  height: 3px;' +
      '  margin: 12px auto 0;' +
      '  background: #00a99e;' +
      '  border-radius: 99px;' +
      '}' +
      'input,' +
      'input[type="text"],' +
      'input[type="email"] {' +
      '  font-family: "DM Sans", sans-serif !important;' +
      '  color: #042b39 !important;' +
      '  background: #f7fafa !important;' +
      '}' +
      'label {' +
      '  font-family: "DM Sans", sans-serif !important;' +
      '  color: #3d5a62 !important;' +
      '}' +
      'button[type="submit"] {' +
      '  font-family: "DM Sans", sans-serif !important;' +
      '  font-weight: 500 !important;' +
      '  letter-spacing: 0.01em !important;' +
      '  background: #042b39 !important;' +
      '  color: #ffffff !important;' +
      '  border-radius: 100px !important;' +
      '  transition: background 0.2s ease !important;' +
      '}' +
      'button[type="submit"]:hover {' +
      '  background: #00a99e !important;' +
      '}' +
      '[aria-label="Close modal"] {' +
      '  display: inline-flex !important;' +
      '  align-items: center !important;' +
      '  justify-content: center !important;' +
      '  width: 32px !important;' +
      '  height: 32px !important;' +
      '  background: rgba(255,255,255,0.94) !important;' +
      '  color: #042b39 !important;' +
      '  border-radius: 50% !important;' +
      '  box-shadow: 0 2px 8px rgba(4, 43, 57, 0.16) !important;' +
      '}' +
      '[aria-label="Close modal"]:hover {' +
      '  background: #ffffff !important;' +
      '}' +
      'p {' +
      '  font-family: "DM Sans", sans-serif !important;' +
      '  color: #3d5a62 !important;' +
      '}' +
      '[data-testid="form-teaser"] {' +
      '  overflow: hidden !important;' +
      '  background-color: #042b39 !important;' +
      '  background-image: linear-gradient(90deg, rgba(4,43,57,0.28) 0%, rgba(4,43,57,0.52) 100%), ' + photo + ' !important;' +
      '  background-size: cover !important;' +
      '  background-position: center 40% !important;' +
      '  background-repeat: no-repeat !important;' +
      '  border: 1px solid rgba(255,255,255,0.2) !important;' +
      '}' +
      '[data-testid="form-teaser"] h3 {' +
      '  color: #ffffff !important;' +
      '  font-family: "DM Sans", sans-serif !important;' +
      '  font-weight: 500 !important;' +
      '  letter-spacing: 0.04em !important;' +
      '  text-shadow: 0 1px 8px rgba(4, 43, 57, 0.55);' +
      '}' +
      '[data-testid="form-teaser"] [aria-label="Close modal"] {' +
      '  width: 28px !important;' +
      '  height: 28px !important;' +
      '  background: rgba(255,255,255,0.94) !important;' +
      '  color: #042b39 !important;' +
      '}' +
      '@media (max-width: 490px) {' +
      '  [role="dialog"][data-sizing="form-wrapper"] > div:first-child {' +
      '    height: 176px !important;' +
      '    min-height: 176px !important;' +
      '    max-height: 176px !important;' +
      '    flex-basis: 176px !important;' +
      '  }' +
      '  [role="dialog"][data-sizing="form-wrapper"] > div:first-child::after {' +
      '    height: 300px;' +
      '  }' +
      '  [role="dialog"][data-sizing="form-wrapper"] [data-amc-welcome-close] {' +
      '    top: 10px !important;' +
      '    right: 10px !important;' +
      '    inset: 10px 10px auto auto !important;' +
      '  }' +
      '}'
    );
  }

  function artUrl() {
    var u = window.AMC_WELCOME_ART || '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u;
  }

  function isFloating(root) {
    return !!root.querySelector('#app-embed[data-layout="floating"], [data-layout="floating"]');
  }

  function dialogLabel(root) {
    var dialog = root.querySelector('[role="dialog"][aria-label]');
    return (dialog && dialog.getAttribute('aria-label')) || '';
  }

  function isWelcomeEmbed(embed) {
    var root = embed.shadowRoot;
    if (!root || !isFloating(root)) return false;
    if (embed.hasAttribute('data-amc-welcome')) return true;
    if (/10%|welcome|community/i.test(dialogLabel(root))) return true;
    return !!root.querySelector('[aria-label="10% Off"], [aria-label*="10%"]');
  }

  function markClose(root) {
    var close = root.querySelector('[aria-label="Close modal"]');
    if (close && close.parentElement && !close.parentElement.hasAttribute('data-amc-welcome-close')) {
      close.parentElement.setAttribute('data-amc-welcome-close', '');
    }
  }

  function hasSheet(root, sheet) {
    var list = root.adoptedStyleSheets;
    if (!list) return false;
    for (var i = 0; i < list.length; i++) {
      if (list[i] === sheet) return true;
    }
    return false;
  }

  function getDesignSheet() {
    var css = cssFor(artUrl());
    if (designSheet && designCss === css) return designSheet;
    designCss = css;
    if (typeof CSSStyleSheet === 'function') {
      try {
        designSheet = new CSSStyleSheet();
        designSheet.replaceSync(css);
        return designSheet;
      } catch (e) {
        designSheet = null;
      }
    }
    return null;
  }

  function applyDesign(root) {
    var sheet = getDesignSheet();
    if (sheet) {
      if (!hasSheet(root, sheet)) {
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      }
      var leftover = root.getElementById(STYLE_ID);
      if (leftover) leftover.remove();
      return;
    }
    var css = cssFor(artUrl());
    var existing = root.getElementById(STYLE_ID);
    if (existing) {
      if (existing.textContent !== css) existing.textContent = css;
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    root.appendChild(style);
  }

  function paintWelcome(embed) {
    var root = embed.shadowRoot;
    if (!root) return;
    embed.setAttribute('data-amc-welcome', '');
    applyDesign(root);
    markClose(root);
    bindDismiss(root);
    if (isDismissed() && !userOpened) {
      closeDialog(root);
      return;
    }
    openTeaserOnce(root);
  }

  var openedOnce = false;
  function openTeaserOnce(root) {
    if (openedOnce || isDismissed()) return;
    if (root.querySelector('[role="dialog"][data-sizing="form-wrapper"]')) {
      openedOnce = true;
      return;
    }
    var teaser = root.querySelector('[data-testid="form-teaser"], [aria-label="10% Off"]');
    if (!teaser) return;
    openedOnce = true;
    teaser.click();
  }

  function closeDialog(root) {
    var close = root.querySelector('[aria-label="Close modal"]');
    if (!close || closing) return;
    closing = true;
    try {
      close.click();
    } finally {
      setTimeout(function () {
        closing = false;
      }, 0);
    }
  }

  function bindDismiss(root) {
    if (root.__amcWelcomeBound) return;
    root.__amcWelcomeBound = true;
    root.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (t.closest('[data-amc-welcome-close], [aria-label="Close modal"]')) {
          markDismissed();
          return;
        }
        if (t.closest('[data-testid="form-teaser"], [aria-label="10% Off"]')) {
          userOpened = true;
        }
      },
      true
    );
  }

  function bind(embed) {
    var root = embed.shadowRoot;
    if (!root) return;

    if (embed.hasAttribute('data-amc-welcome')) applyDesign(root);

    if (lastRoot && lastRoot.get(embed) !== root) {
      lastRoot.set(embed, root);
      new MutationObserver(function () {
        sync(embed);
      }).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label', 'data-layout']
      });
    }

    sync(embed);
  }

  function sync(embed) {
    if (isWelcomeEmbed(embed)) paintWelcome(embed);
  }

  function scan() {
    document.querySelectorAll(EMBED).forEach(bind);
  }

  var url = artUrl();
  if (url) {
    var img = new Image();
    img.src = url;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var scanTimer = null;
  new MutationObserver(function () {
    if (scanTimer) return;
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scan();
    }, 0);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
